import { render, staticRenderFns } from "./SelectPurchaseTerm.vue?vue&type=template&id=12af12ce&"
import script from "./SelectPurchaseTerm.vue?vue&type=script&lang=js&"
export * from "./SelectPurchaseTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports